'use client'

import { usePageTracking } from '@/lib/tracking/hooks/usePageTracking.client'
import type { PageData } from '@/lib/tracking/services/tracking.eventTypes'
import { useMemo } from 'react'
import { useSearchPageTracking } from './useSearchPageTracking.client'

type SearchPageTrackingProps = {
  pageData: PageData
  searchTerm: string
  nbResults: number
  requestFilter: string
}

/**
 * Search-specific tracking component.
 * Forces a new tracking on each searchTerm change.
 */
export function SearchPageTracking({
  pageData,
  searchTerm,
  nbResults,
  requestFilter,
}: SearchPageTrackingProps) {
  usePageTracking(pageData)

  // Create a unique key that combines pageData and searchTerm
  // to force change detection
  const trackingKey = useMemo(
    () => `${pageData.pageType}-${pageData.pageCategory || ''}-${searchTerm}`,
    [pageData.pageType, pageData.pageCategory, searchTerm],
  )

  useSearchPageTracking(trackingKey, searchTerm, nbResults, requestFilter)

  return null
}
